import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
export function ProductShowcase() {
  return <Section background="cream" data-id="element-568">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-569">
        <div className="order-2 md:order-1" data-id="element-570">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-571">
            Diseñado para la vida real
          </h2>
          <p className="text-lg text-gray-600 mb-8" data-id="element-572">
            StingFit es discreto, cómodo y eficaz. Nadie notará que lo llevas
            puesto, pero todos notarán los resultados.
          </p>

          <ul className="space-y-4" data-id="element-573">
            {['Invisible bajo la ropa', 'Adhesivo hipoalergénico suave', 'No interfiere con tu sueño', 'Compatible con tu rutina diaria'].map((item, i) => <li key={i} className="flex items-center gap-3 bg-white p-4 rounded-lg shadow-sm" data-id="element-574">
                <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center" data-id="element-575">
                  <Check className="w-4 h-4 text-[#2D5016]" data-id="element-576" />
                </div>
                <span className="font-medium text-gray-800" data-id="element-577">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="order-1 md:order-2 flex justify-center" data-id="element-578">
          <div className="relative w-full max-w-md" data-id="element-579">
            <div className="absolute inset-0 bg-[#D4AF37]/20 rounded-full blur-3xl" data-id="element-580"></div>
            <img src="https://cdn.magicpatterns.com/uploads/q5pbc7UPXB7yZsJKNiRqwd/LymphoriaX_(6).png" alt="Paquete StingFit Premium" className="relative z-10 w-full drop-shadow-2xl hover:scale-105 transition-transform duration-500" data-id="element-581" />
          </div>
        </div>
      </div>
    </Section>;
}